import React, { useState, useEffect } from 'react';
import { AppBar, Toolbar, Typography, Button, Modal, Paper, TextField, IconButton, InputAdornment } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import UserAvatar from 'react-user-avatar';
import { Link, useNavigate } from 'react-router-dom';
import { UnfoldLess, Visibility, VisibilityOff } from '@material-ui/icons';
import { deepOrange } from '@mui/material/colors';
import { Stack } from '@mui/material';



const Header = () => {
  const [isLoginModalOpen, setLoginModalOpen] = useState(false);
  const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);
  const [name, setName] = useState();


  const [state, setState] = useState({
    userName: null,
    password: null,
    suserName: null,
    semail: null,
    spassword: null,
    token: null,
  });

  useEffect(() => {
    updateUser(window.localStorage.userID)
    setState((prevState) => ({
      ...prevState,
      token: window.localStorage.getItem("token"),
    }));
  }, []);


  const updateUser = (idToUpdateUser) => {
    axios.post(
      process.env.REACT_APP_BASE_URL + 'users/update-user',
      {
        id: idToUpdateUser,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': window.localStorage.getItem("token")
        }
      }
    )
      .then((response) => {
        if (response.status === 200) {

          setName(response.data.name);
        }
      })
      .catch((error) => {
        console.log('err', error);
      });
  };

  const openLoginModal = () => {
    setLoginModalOpen(true);
  };

  const openLogoutModal = () => {
    window.localStorage.setItem("token", "");
    toast.success("Successfully Logout", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
    window.location.reload(false);
  };

  const closeLoginModal = () => {
    setLoginModalOpen(false);
  };

  const openSignUpModal = () => {
    setSignUpModalOpen(true);
    closeLoginModal(); // Close the Login popup when opening SignUp
  };

  const closeSignUpModal = () => {
    setSignUpModalOpen(false);
  };

  const handleChangeUserName = (event) => {
    setState((prevState) => ({
      ...prevState,
      userName: event.target.value,
    }));
  }

  const handleChangeSingUserName = (event) => {
    setState((prevState) => ({
      ...prevState,
      suserName: event.target.value,
    }));
  }

  const handleChangeSingemailName = (event) => {
    setState((prevState) => ({
      ...prevState,
      semail: event.target.value,
    }));
  }

  const handleChange = (prop) => (event) => {
    setState({ ...state, [prop]: event.target.value });
  };

  const handleTogglePasswordVisibility = (field) => {
    setState({ ...state, [field]: !state[field] });
  };

  const handleChangeSingPassword = (event) => {
    setState((prevState) => ({
      ...prevState,
      spassword: event.target.value,
    }));
  }

  const handleChangePassword = (event) => {
    setState((prevState) => ({
      ...prevState,
      password: event.target.value,
    }));
  }
  const requestData = {
    email: state.userName,
    password: state.password,
  };

  const headleloginUpModal = () => {
    axios.post(process.env.REACT_APP_BASE_URL + 'users/login', requestData, {
      headers: { 'Content-Type': 'application/json' },
    }).then((response) => {
      // navigate('/your-bicycle', { state: { bicycle: response.data.bicycle } });
      console.log('aaaaaaaaaaaaaaaa', response.data);
      if (response.status === 200) {
        window.location.reload()
        window.localStorage.setItem("token", response.data.token);
        window.localStorage.setItem("userID", response.data.user.id);
        closeLoginModal();
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        closeLoginModal();
        toast.error(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
      .catch((error) => {
        // console.error('Error:', error);
        closeLoginModal();
        toast.error(error.response.data.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }

  const srequestData = {
    name: state.suserName,
    email: state.semail,
    password: state.spassword,
  };

  const headleSingUPUpModal = () => {

    if (state.spassword !== state.sconfirmPassword) {
      // Passwords don't match, handle error
      return setState((prevState) => ({
        ...prevState,
        isNotSame: true
      }));
    }
    axios.post(process.env.REACT_APP_BASE_URL + 'users/register', srequestData, {
      headers: { 'Content-Type': 'application/json' },
    }).then((response) => {
      // navigate('/your-bicycle', { state: { bicycle: response.data.bicycle } });
      console.log('aaaaaaaaaaaaaaaa', response.status);
      if (response.status === 201) {
        window.localStorage.setItem("token", response.data.token);
        window.localStorage.setItem("userID", response.data.user.id);
        closeSignUpModal();
        toast.success(response.data.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });

        // window.localStorage.setItem("token", response.data.token);

      } else {
        closeSignUpModal();
        toast.error(response.data.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
    })
      .catch((error) => {
        closeSignUpModal();
        toast.error(error.response.data.error, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      });
  }

  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate('/mybicycle');
  };


  return (
    <div>
      {console.log('name', name)}
      <AppBar position="fixed" className="header">
        <Toolbar >
          <Typography variant="h6" style={{ flexGrow: 1 }}>
            <Link to="/" style={{ textDecoration: 'none', color: 'white' }}><img className='logoMystable' src='/MyStableLogo.svg'></img></Link>
          </Typography>
          {!window.localStorage.getItem("token") ? (
            <>
              <Button style={{ fontWeight: 'bold' }} color="black" onClick={openLoginModal}>
                Login
              </Button>
            </>
          ) : (
            <>
              <Button
                onClick={handleButtonClick}
                className='my-bicycles'
              >
                My Bicycles
              </Button>

              {/* <a color="inherit" href="/mybicycle">
                My Bicycles
              </a> */}


              <Button style={{ fontWeight: 'bold' }} color="black" onClick={openLogoutModal}>
                Logout
              </Button>

              <UserAvatar color="#FB7619" size="48" name={`${name}`} />

            </>
          )}

        </Toolbar>
      </AppBar>

      <Modal open={isLoginModalOpen} onClose={closeLoginModal}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Paper style={{ padding: '20px', maxWidth: '500px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" gutterBottom>
                Login
              </Typography>
              <IconButton edge="end" color="inherit" onClick={closeLoginModal}>
                <CloseIcon />
              </IconButton>
            </div>
            <TextField
              label="Username"
              fullWidth
              value={state.value}
              onChange={handleChangeUserName}
            />
            <TextField
              label="Password"
              type="password"
              fullWidth
              value={state.value}
              onChange={handleChangePassword}
            />
            <Button variant="contained" color="primary" onClick={headleloginUpModal} className="login-submit-button">
              Login
            </Button>
            <p className="sign-up-message">
              Don't have an account yet? <a onClick={openSignUpModal}><u>Sign Up Here</u></a>
            </p>
          </Paper>
        </div>
      </Modal>

      <Modal open={isSignUpModalOpen} onClose={closeSignUpModal}>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Paper style={{ padding: '20px', maxWidth: '500px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Typography variant="h6" gutterBottom>
                Sign Up
              </Typography>
              <IconButton edge="end" color="inherit" onClick={closeSignUpModal}>
                <CloseIcon />
              </IconButton>

            </div>

            <form>
              <TextField
                label="Name"
                margin="normal"
                fullWidth
                onChange={handleChangeSingUserName}
              // Add other props as needed
              />
              <TextField
                label="Email"
                type="email"
                margin="normal"
                fullWidth
                onChange={handleChangeSingemailName}
              // Add other props as needed
              />
              <TextField
                label="Password"
                type={state.showPassword ? 'text' : 'password'}
                value={state.spassword}
                onChange={handleChange('spassword')}
                margin="normal"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleTogglePasswordVisibility('showPassword')}>
                        {state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />

              <TextField
                label="Confirm Password"
                type={state.showConfirmPassword ? 'text' : 'password'}
                value={state.sconfirmPassword}
                onChange={handleChange('sconfirmPassword')}
                margin="normal"
                fullWidth
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={() => handleTogglePasswordVisibility('showConfirmPassword')}>
                        {state.showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={headleSingUPUpModal}
                className="login-submit-button"
              // Add onClick or onSubmit handler
              >
                Sign Up
              </Button>
              {console.log(state.isNotSame, "isnotsame")}
              {state.isNotSame && (
                <div style={{ color: 'red' }}>Passwords don't match</div>
              )}
            </form>

          </Paper>
        </div>
      </Modal>
      <div>
        <ToastContainer />
      </div>
    </div>
  );
};

export default Header;
